<template>
  <div class="home">
    <v-tabs show-arrows>
      <v-tabs-slider></v-tabs-slider>
      <v-tab to="/">みんなの会話デッキ</v-tab>
      <v-tab to="/recently-created">最近作った会話デッキ</v-tab>
      <v-spacer></v-spacer>
      <!--
      <v-tab to="/recently-created">最近作った会話デッキ</v-tab>
      <v-tab to="/favorite">お気に入りの会話デッキ</v-tab> -->
    </v-tabs>
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {},
};
</script>
